const queryKeys = {
  baseCompanyInfo: 'baseCompanyInfo',
  allCompanies: 'allCompanies',
  messaging: 'messaging',
  companyUserList: 'companyUsers',
  user: 'user',
  companyRegistrationInfo: 'companyRegistrationInfo',
  companyUnspscSelection: 'companyUnspscSelection',
  companyDetails: 'companyDetails',
  hasConnectionToCompany: 'hasConnectionToCompany',
  connectedCompanies: 'connectedCompanies',
  companyDocuments: 'companyDocuments',
  requiredDocumentTypes: 'requiredDocumentTypes',
  companyProfileSettings: 'companyProfileSettings',
  companyBeeDetails: 'companyBeeDetails',
  validBeeLevels: 'validBeeLevels',
  companyBeeDetailsById: 'companyBeeDetailsById',
  companyCoidaDetails: 'companyCoidaDetails',
  companyTaxInformation: 'companyTaxInformation',
  companyBankingDetails: 'companyBankingDetails',
  receivedConnectionRequests: 'receivedConnectionRequests',
  existingConnectionRequestWithCompany: 'existingConnectionRequestWithCompany',
  searchChatMessages: 'searchChatMessages',
  companyProfileView: 'companyProfileView',
  companyProfileImage: 'companyProfileImage',
  connectionRequestsMade: 'connectionRequestsMade',
  connectionRequestsReceived: 'connectionRequestsReceived',
  defaultUserCompanyId: 'defaultUserCompanyId',
  tempCompanySupplierRecord: 'tempCompanySupplierRecord',
  invitationCompanyRecord: 'invitationCompanyRecord',
  userPermissions: 'userPermissions',
  companySearch: 'companySearch',
  companyActiveUserCounts: 'companyActiveUserCounts',
  dashboardStats: 'dashboardStats',
  getNotificationById: 'getNotificationById',
  companyShareholderDetails: 'companyShareholderDetails',
  shareHolderDocument: 'shareHolderDocument',
  getShareholderDetailById: 'getShareholderDetailById',
  useGetBusinessUnitDataByFieldConfig: 'useGetBusinessUnitDataByFieldConfig',
  useGetCompanyActiveRolesData: 'useGetCompanyActiveRolesData',
  useGetCompanyUsersData: 'useGetCompanyUsersData',
  // match & clean
  masterData: 'masterData',
  allVerificationAgencies: 'allVerificationAgencies',
  activeVerificationAgencies: 'activeVerificationAgencies',
  dataManagementPartners: 'dataManagementPartners',
  dataManagementPartnerClients: 'dataManagementPartnerClients',
  masterCompanyRecords: 'masterCompanyRecords',
  partnerClients: 'partnerClients',
  supplierFeedbackCategories: 'supplierFeedbackCategories',
  historicalSupplierFeedback: 'historicalSupplierFeedback',
  bBbeeDocument: 'bBbeeDocument',
  documentByTypeId: 'documentByTypeId',
  masterCompanyRecordElastic: 'masterCompanyRecordElastic',
  matchAndClean: 'matchAndClean',

  // documents
  documentByDocumentType: 'documentByDocumentType',
  getCompanyDocumentById: 'getCompanyDocumentById',

  // compliance
  inoxicoCompanyDetails: 'inoxicoCompanyDetails',
  inoxicoAdditionalCompanyDetails: 'inoxicoAdditionalCompanyDetails',
  companySupportingFileIds: 'companySupportingFileIds',

  // onboarding workflows
  fieldConfiguration: 'fieldConfiguration',
  onboardingFieldConfiguration: 'onboardingFieldConfiguration',
  documentConfiguration: 'documentConfiguration',
  supplierTypesConfiguration: 'supplierTypesConfiguration',
  motivationToOnboardById: 'motivationToOnboardById',
  motivationToOnboardBySupplierCompanyId: 'motivationToOnboardBySupplierCompanyId',
  clientSpecificSuppliers: 'clientSpecificSuppliers',
  onboardingWorkflowInstanceByMtoId: 'onboardingWorkflowInstance',
  workflowActionHistory: 'workflowActionHistory',
  onboardingEscalation: 'onboardingEscalation',
  motivationToOnboardRequestsSent: 'motivationToOnboardRequestsSent',
  maxConfiguredApprovalStage: 'maxConfiguredApprovalStage',
  onboardedSupplierErpNumberByWorkflowInstanceId:
    'onboardedSupplierErpNumberByWorkflowInstanceId',
  motivationToOnboardRequestsReceived: 'motivationToOnboardRequestsReceived',
  onboardingWorkflowStage: 'onboardingWorkflowStage',
  onboardingIsFinalApprovalStage: 'onboardingIsFinalApprovalStage',

  // notification
  unReadUserNotifications: 'unReadUserNotifications',

  // static data
  beeLevels: 'beeLevels',
  beeTurnoverBands: 'beeTurnoverBands',
  beeSectorTurnoverBands: 'beeSectorTurnoverBands',
  companyTypes: 'companyTypes',
  countries: 'countries',
  documentTypes: 'documentTypes',
  provinces: 'provinces',
  municipalities: 'municipalities',
  unspscOptions: 'unspscOptions',
  beeSectors: 'beeSectors',
  beeRatingSources: 'beeRatingSources',
  bankList: 'bankList',
  bankAccountTypes: 'bankAccountTypes',
  companyComplianceSummary: 'companyComplianceSummary',
  userProfile: 'userProfile',
  financialYearEndMonths: 'financialYearEndMonths',
  reportFrequencies: 'reportFrequencies',
  beeTurnoverBandsBySector: 'BeeTurnoverBandsBySector',
  activeRoles: 'activeRoles',
  activeDefaultSystemRoles: 'activeDefaultSystemRoles',

  //My connections
  searchMyClientsData: 'searchMyClientsData',
  searchMySuppliersData: 'searchMySuppliersData',
  invitedCompanies: 'invitedCompanies',

  //BBB-EE Tasks
  bbbeeTask: 'bbbeeTask',

  // multi-company
  userCompanies: 'userCompanies',

  // branch approval requests (Epic #4183, #6070)
  pendingBranchApprovalRequests: 'pendingBranchApprovalRequests',
  linkedBranchCompanies: 'linkedBranchCompanies',

  // document validation
  allRequiredDocumentTypes: 'allRequiredDocumentTypes',

  // feature flags (#6449)
  featureFlags: 'featureFlags',

  // QA Playground Mode (Feature #8075, PBI #8080)
  playgroundMode: 'playgroundMode',

  // My Suppliers advanced-search filter options (PBI #6560)
  mySuppliersSpendCategories: 'mySuppliersSpendCategories',
  mySuppliersPaymentTerms: 'mySuppliersPaymentTerms',
  mySuppliersDevelopmentClassifications: 'mySuppliersDevelopmentClassifications',
  mySuppliersSupplierTypes: 'mySuppliersSupplierTypes',

  // ERP sync / supplier-update-approval gating configuration (PBI #6094)
  erpCategoryConfig: 'erpCategoryConfig',
  supplierUpdateClientSettings: 'supplierUpdateClientSettings',

  // Pending Approvals Inbox (PBI #6096)
  pendingApprovals: 'pendingApprovals',
  companyBaseInfoById: 'companyBaseInfoById',

  // ERP Sync tab on ViewCompanyProfileV2 (PBI #6095)
  stagedSupplierUpdateDetail: 'stagedSupplierUpdateDetail',
  lastApprovedSnapshots: 'lastApprovedSnapshots',
  supplierUpdateAudit: 'supplierUpdateAudit',

  // Feature #7210 — persistent supplier update records + decided-section history
  supplierUpdateRecords: 'supplierUpdateRecords',
  supplierUpdateHistory: 'supplierUpdateHistory',

  // Feature #7210 / US-09-10 — frontend-triggered Compliance verification reports
  complianceVerificationProducts: 'complianceVerificationProducts'
};

export default queryKeys;
